
import React from 'react';

const MapContainer = () => {
  return (
    <iframe
      title="Charupath Hateykhari School (CHS)"
      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d228.1337707552059!2d90.35595398679088!3d23.81360838525793!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3755c1da0ebd4279%3A0x1fa9187c5c19640b!2sCharupath%20Hateykhari%20School!5e0!3m2!1sen!2sbd!4v1683877255085!5m2!1sen!2sbd"
      width="100%"
      height="215px"
      style={{ border: 'none', borderRadius: '0.5rem' }}
      allowFullScreen=""
      loading="lazy"
      referrerPolicy="no-referrer-when-downgrade"
    ></iframe>
  );
};

export default MapContainer;
